/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAgendaFill: {
  name: 'agenda-fill';
  data: string;
} = {
  name: 'agenda-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Zm0 10a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4Z" fill="currentColor"/></svg>`,
};
